(function () {
  if (window.MREquilibriumInitialized) return;
  window.MREquilibriumInitialized = true;

  function setVisible(el) {
    var delay = parseFloat(el.getAttribute('data-delay') || '0');
    el.style.transitionDelay = delay + 's';
    el.classList.add('is-visible');
  }

  function initReveals(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.mr-eq-reveal');

    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(setVisible);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          setVisible(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -5% 0px'
      }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initHeroScroll(scope) {
    var root = scope || document;
    var heroes = root.querySelectorAll('[data-mr-eq-hero]');

    heroes.forEach(function (hero) {
      if (hero.classList.contains('is-scroll-ready')) return;

      var scroll = hero.querySelector('[data-mr-eq-scroll]');
      if (!scroll) return;

      hero.classList.add('is-scroll-ready');

      window.setTimeout(function () {
        scroll.classList.add('is-visible');
      }, 350);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
    initHeroScroll(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initReveals(document);
    initHeroScroll(document);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initReveals(document);
    initHeroScroll(document);
  });

  window.addEventListener('pageshow', function () {
    initHeroScroll(document);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initReveals(document);
    initHeroScroll(document);
  }
})();